'use client'

import { usePathname } from 'next/navigation'
import { useMemo } from 'react'
import { useQueryState } from './use-query-state'

const forbiddenQueryParams = ['Global.', 'categoryPath', 'path']

// Replaces need for pageUri & queryParams
const useCleanRouter = () => {
  const path = usePathname()
  const { queryString } = useQueryState()

  const data = useMemo(() => {
    const pageUri = path ? `${path}?${queryString}` : ''

    // localhost is only used to construct the URL
    const url = new URL(pageUri, 'http://localhost')

    const searchParams = new URLSearchParams(url.search)

    // TODO: remove when params are not sent from storwebben anymore
    url.searchParams.forEach((_, key) => {
      if (forbiddenQueryParams.some(p => key.includes(p))) {
        searchParams.delete(key)
      }
    })

    const updatedSearchParams = searchParams.toString() !== '' ? `?${searchParams.toString()}` : ''

    return {
      pageUri: url.pathname + updatedSearchParams,
      pageUriWithoutQuery: url.pathname,
      query: searchParams,
    }
  }, [queryString, path])

  return data
}

export default useCleanRouter
